import React from 'react';
import { Star } from 'lucide-react';
import { motion } from 'framer-motion';

const reviews = [
  {
    name: "Daniel Møller Kongsgaard",
    text: "KC Detailer gør et flot, passioneret og ærefyldt arbejde. De har stor erfaring med forskellige Coating produkter og finder det der passer bedst til din lak.",
    rating: 5
  },
  {
    name: "Ole Jensen",
    text: "Vi har i dag hentet vores RAV4. Den har fået en keramisk coating. Utrolig flot blank bil. Fantastisk resultat. Rigtig god service. Kan klart anbefales.",
    rating: 5
  },
  {
    name: "Robert M.",
    text: "Fik klargjort min bil, som skulle afleveres tilbage til leasingselskabet. Super godt resultat, den ser helt ny ud igen! Kommer helt sikkert igen!",
    rating: 5
  },
  {
    name: "Torben Bjerrehuus",
    text: "Fremragende arbejde, min Citroën C5 X står som fuldstændig ny. Det har været alle pengene værd. KC Detailer kan stærkt anbefales.",
    rating: 5
  }
];

export default function Testimonials() {
  return (
    <section className="py-20 bg-slate-50 overflow-hidden">
      <motion.div 
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6 }}
        className="max-w-7xl mx-auto px-4 mb-12 flex justify-between items-end"
      >
        <div>
          <h2 className="text-slate-500 font-bold tracking-widest uppercase text-sm mb-4">Anmeldelser</h2>
          <h3 className="text-3xl font-black text-slate-900 uppercase">Det siger vores kunder</h3>
        </div>
        <div className="hidden md:flex items-center gap-2 bg-white px-4 py-2 rounded-full border border-slate-200">
          <span className="font-bold">4.9/5</span>
          <div className="flex text-yellow-400">
            {[...Array(5)].map((_, i) => <Star key={i} size={14} fill="currentColor" />)}
          </div>
          <span className="text-slate-400 text-sm">på Google</span>
        </div>
      </motion.div>

      <div className="flex animate-marquee gap-6">
        {[...reviews, ...reviews].map((review, index) => (
          <div 
            key={index} 
            className="flex-shrink-0 w-[350px] bg-white p-8 rounded-3xl border border-slate-100 shadow-sm"
          >
            <div className="flex text-yellow-400 mb-4">
              {[...Array(review.rating)].map((_, i) => <Star key={i} size={16} fill="currentColor" />)}
            </div>
            <p className="text-slate-600 italic mb-6 leading-relaxed">"{review.text}"</p>
            <p className="font-bold text-slate-900">— {review.name}</p>
          </div>
        ))}
      </div>

      <style dangerouslySetInnerHTML={{ __html: `
        @keyframes marquee {
          0% { transform: translateX(0); }
          100% { transform: translateX(-50%); }
        }
        .animate-marquee {
          animation: marquee 40s linear infinite;
        }
      `}} />
    </section>
  );
}
